import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { FeaturesMainCardComponent } from './features-main-card.component';


@NgModule({
  declarations: [
    FeaturesMainCardComponent
  ],
  exports: [
    FeaturesMainCardComponent
  ],
  imports: [
    CommonModule,
    NgOptimizedImage,
    RouterLink,
    TranslateModule
  ]
})
export class FeaturesMainCardModule { }
